import { PersonelEkleGuncellePage } from './../personel-ekle-guncelle/personel-ekle-guncelle';
import { CariIslemPage } from './../cari-islem/cari-islem';
import { CariOdemePage } from './../../cari-odeme/cari-odeme';
import { CarialacakdekontPage } from './../carialacakdekont/carialacakdekont';
import { CariHareketleriPage } from './../cari-hareketleri/cari-hareketleri';
import { CariborcdekontPage } from './../cariborcdekont/cariborcdekont';
import { CariTahsilatPage } from './../cari-tahsilat/cari-tahsilat';
import { CarieklePage } from './../cariekle/cariekle';
import { ModalController } from 'ionic-angular/components/modal/modal-controller';
import { BllOrtak } from './../../../providers/bll/bll-ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams, ActionSheetController } from 'ionic-angular';
import { Ortak } from '../../../providers/ortak';

/**
 * Generated class for the PersonelListesiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-personel-listesi',
  templateUrl: 'personel-listesi.html',
})
export class PersonelListesiPage {
  aranan = "";
  skip: number = 0;
  take: number = 50;
  cariListesi = [];

  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public modalCtrl:ModalController,
    public actionSheetCtrl:ActionSheetController,
     public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.cariAra(null);
  }
  cariAra(e) {
    var formData = new FormData();
    formData.append("aranan", this.aranan);
    formData.append("skip", this.skip.toString());
    formData.append("take", this.take.toString());
    this.bllOrtak.islem(formData, "PersonelListesi","", false).then(a => {
     
      var sonuc = <any>a;
      this.cariListesi = sonuc.SonucObject;
  
 
    })
  }
  urunler(e) {

    if (e.keyCode == 13) {
      this.cariAra(e);
    }
  }
  yeni() {
    let modal = this.modalCtrl.create(PersonelEkleGuncellePage);
    modal.onDidDismiss(data => {
      this.ionViewDidLoad();
    });

    modal.present();

  }
  CariSil(cari) {
    this.ortak.showConfirmAlert("Uyarı", "Kayıt silinecektir. Devam etmek istiyor musunuz?").then(k => {
      var formData = new FormData();
      
      formData.append("LogicalRef", cari.ID);

      this.bllOrtak.islem(formData, "CariSil", "", true).then(a => {

      }).catch(x => {

        this.ortak.showErrorAlert();
      })
      this.cariAra(null);
    })

}
CariGuncelle(kisi) {
  let modal = this.modalCtrl.create(PersonelEkleGuncellePage, { vwCari: kisi });
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();

}
CariTahsilat(kisi) {
  let modal = this.modalCtrl.create(CariTahsilatPage, { vwCari: kisi });
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();

}
CariDekont(kisi){
  let modal=this.modalCtrl.create(CariborcdekontPage,{vwCari:kisi});
  modal.onDidDismiss(data=>{
    this.ionViewDidLoad();
  })
  modal.present();
}
carihareketleri(kisi){
  let modal=this.modalCtrl.create(CariHareketleriPage,{vwCari:kisi});
  modal.onDidDismiss(data=>{
    this.ionViewDidLoad();
  })
  modal.present();

}
CariAlacak(kisi){
  let modal=this.modalCtrl.create(CarialacakdekontPage,{vwCari:kisi});
  modal.onDidDismiss(data=>{
    this.ionViewDidLoad();
  })
  modal.present();
}
CariOdeme(kisi){
  let modal = this.modalCtrl.create(CariOdemePage,{ vwCari: kisi });
  modal.onDidDismiss(data => {
    this.ionViewDidLoad();
  });
  modal.present();
}
CariIslemleri(kisi){
  let modal=this.modalCtrl.create(CariIslemPage,{vwCari:kisi});
  modal.onDidDismiss(data=>{
    this.ionViewDidLoad();
   
  });
  modal.present();
  
}
Islemler(kisi) {
  const actionSheet = this.actionSheetCtrl.create({
    title: 'Cari  İşlemleri',
    buttons: [
      {
        text: 'Cari Hareketleri',

        handler:()=>{
      this.carihareketleri(kisi);
        }
       
      },
      {
        text: 'Alacak Dekontu',

        handler:()=>{
        this.CariAlacak(kisi);
        }
       
      },
      {
        text: 'Borç Dekontu',

        handler:()=>{
        this.CariDekont(kisi);
        }
       
      },
      {
        text: 'Tahsilat Yap',

        handler:()=>{
        this.CariTahsilat(kisi);
        }
       
      },
      {
        text: 'Ödeme Yap',

        handler:()=>{
          this.CariOdeme(kisi);
        }
       
      },{
        text: 'Düzenle',
        handler: () => {
         this.CariGuncelle(kisi);
        }
      },{
        text: 'İptal ',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }
    ]
  });
  actionSheet.present();
}


}



// WEBPACK FOOTER //
// ./src/pages/CariIslemleri/personel-listesi/personel-listesi.ts